import React, { useContext } from "react";
import { Label } from "@pmi/nyx-design-system";
import { ApiContext } from "../../context/apicontext";

// Performance card code (after click on performance option then open card)
function PerformanceCard({ selectPerformanceData }) {
  const { performanceData } = useContext(ApiContext);
  return (
    <>
      <div className="performace-panel">
        <div className="accordion px-2" id="performaceAccordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id="performace">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#performaceCollapse"
                aria-expanded="true"
                aria-controls="collapse"
              >
                <div>
                  <h5>{selectPerformanceData}</h5>
                  <h6 className="coverage-subtitle">{performanceData?.subtitle}</h6>
                </div>
              </button>
            </h2>
            <div
              id="performaceCollapse"
              className="accordion-collapse collapse show mt-2"
              aria-labelledby="performace"
              data-bs-parent="#performaceAccordion"
            >
              <div className="accordion-body">
                <div className="demographics-data">
                  <Label className="text-transform-none fw-bold small">Territory</Label>
                  <Label className="text-transform-none fw-bold small">Actual</Label>
                  <Label className="d-flex align-items-center fw-bold small">Contribution</Label>
                </div>
                {performanceData?.data?.map((row, index) => (
                  <div key={index} className="tab-data">
                    <Label className="text-transform-none">{row.territory}</Label>
                    <span>{row.actual}</span>
                    <span>{row.contribution}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="performace-panel">
        <div className="p-2">
          <div className="d-flex align-items-start justify-content-between">
            <div>
              <h4>{performanceData.title}</h4>
              <h6 className="mb-3 coverage-subtitle">{performanceData.subtitle}</h6>
            </div>
            <Icon color="black" role="button" data-testid="icon-test" name="close" size="large" className="close-icon" onClick={() => { isCloseSidebar(false) }} />
          </div>
          <div className="demographics-data">
            <Label className="text-transform-none fw-bold small">Territory</Label>
            <Label className="text-transform-none fw-bold small">Actual</Label>
            <Label className="d-flex align-items-center fw-bold small">Contribution</Label>
          </div>
          {performanceData.data.map((row, index) => (
            <div key={index} className="tab-data">
              <Label className="text-transform-none">{row.territory}</Label>
              <span>{row.actual}</span>
              <span>{row.contribution}</span>
            </div>
          ))}
        </div>
      </div> */}
    </>
  );
}

export default PerformanceCard;
